import { Component, OnInit, OnDestroy, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiService } from '../../services/ui.service';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { MenuItem } from 'primeng/api';
import { Grid2Service } from './grid2.service';
import { Grid2Model } from './grid-2-model';
import { AppSettings } from '../../app.settings';
import { StorageService } from '../../services/storage.service';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { UserCommonService } from '../../services/user-common.service';

@Component({
  selector: 'app-mi-grid-v2',
  providers: [Grid2Service],
  templateUrl: './mi-grid-2.component.html'
  // templateUrl: './mi-grid-2.component-old.html'
})

export class MiGrid2Component implements OnInit, OnDestroy {
  subscription: Subscription;
  rowData: any[] = [];
  search = '';
  moreActionsItems: MenuItem[] = [];
  @Output() rowClickedEvent = new EventEmitter<any>();
  @Output() totalCount = new EventEmitter<any>();
  @Output() actionBtnClickedEvent = new EventEmitter<any>();
  @Output() getGridReference: EventEmitter<any> = new EventEmitter();
  @Input() url: any = '';
  @Input() bottomSearchBar: Boolean;
  @Input() isDetailScreen: Boolean;
  @Input() bottomExportButton: Boolean;
  @Input() rowSelection = 'single';
  @Input() printUrl: any = '';
  @Input() exportUrl: any = '';
  @Input() columnDefs: any[] = [];
  @Input() actionButtonsDefs: any[] = [];
  @Input() pagination: any = true;
  @Input() paginationPageSize: any = 15;
  @Input() paginationStartPage: any = 0;
  @Input() defaultSortField = '';
  @Input() divClass = '';
  @Input() serialNumber;
  @Input() pageDetailsLink = '';
  @Input() pageEditLink = '';
  @Input() pageReportDetailsLink = '';
  @Input() passengerId = '';
  queryParams: any = '';
  enableResizer = 'false';
  @Input() overlayLoadingTemplate: any = '<span class="ag-overlay-loading-center" "style=background:red">' +
    'Please wait while your rows are loading</span>';
  datasource = [];
  model: Grid2Model;
  totalRecords = 0;
  sortF = '';
  first: any = 0;
  sortO = '';
  offset = 0;
  setRowLength = 10;
  searchText = '';
  selectedRecords: any = [];
  pdfReportSupport = false;
  @Input() uniqId;

  displayImportPopup = false;
  uploadedFileName;
  @Input() screenCode: any = '';
  @Input() bulkImportButton: any = false;
  @Output() filterGridEvent = new EventEmitter<any>();
  @Input() isFilterButtonDisplay: any = false;


  constructor(
     private elm: ElementRef,
     private uiService: UiService,
     private gridService: Grid2Service,
     private commonBindingDataService: CommonBindingDataService,
    private userCommonService: UserCommonService,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.subscription = this.uiService.sidebarToggledEvent
      .subscribe((state: string) => {
        this.refreshList();
      });
      this.setGridPagination();
      this.initMoreActionsMenu();
  }

  onResize(event: any) {
    // this.refreshList();
  }

  refreshList() {
    this.fetchAndLoadData();
  }

  fetchAndLoadData() {
    const that = this;
    this.gridService.loadGridData(that.getUrl(that.url)).subscribe(result => {
      const model = <Grid2Model>result;
      if (result !== undefined) {
        this.totalRecords = model.count;
        that.datasource = [];

        if (that.serialNumber) {
          // let serialNo = this.offset? (this.offset + 1) : (this.offset + 1);
          for (let i = 1, j = this.offset + 1; i <= model.data.length; i++, j++) {
            model.data[i - 1]['serialNo'] = j;
          }
        }


        model.data.forEach(e => {
          that.columnDefs.forEach(c => {
            if (c && c.cellRenderer) {
              // console.log(c.cellRenderer);
              e[c.field] = c.cellRenderer(e[c.field]);
            } else if (c && c.cellRendererHtml) {
              e[c.field] = c.cellRendererHtml(e);
            }

            that.actionButtonsDefs.forEach(d => {
              if (d.show) {
                e[d.field] = d.show(e);
              }
            });
          });
          that.datasource.push(e);
        });
      }
      this.totalCount.emit(this.totalRecords);
    });
  }

  getUrl(url) {
    
    const obj = {
      uniqId: this.uniqId,
      pageData: {
        offset: this.offset,
        searchText: this.searchText || this.search
      }
    }
    this.updatePageDataToLocal(obj);
    const that = this;
    let params = 'searchText=' + this.searchText + '&offset=' + this.offset + '&limit=' + this.setRowLength;

    params += '&sortColumn=';
    params += this.sortF;
    params += '&sortType=';
    params += this.sortO;
    let buildUrl = url;
    if (url.lastIndexOf('?') < 0) {
      buildUrl += '?';
    } else {
      buildUrl += '&';
    }
    buildUrl += params;

    return buildUrl;
  }

  checkScroll() {

  }

  public onQuickFilterChanged($event, dt) {
    if (this.search === '') {
      this.search = this.searchText = '';
      this.refreshList();
    }

    if ($event.key === 'Enter') {
      this.applySearch(this.search);
      dt.first = 0;
    }
  }

  updateUrl(url: string) {
    this.url = url;
    this.offset = 0;
    this.first = 0;
    const paramArray: any[] = this.url.split('?');
    if (paramArray.length > 1) {
      this.queryParams = paramArray[1];
    }
    this.refreshList();
  }

  loadDatasourceLazy(event: LazyLoadEvent) {
    // console.log(event);
    // console.log(this.paginationStartPage);
    this.sortF = this.defaultSortField;
    this.offset = event.first;
    this.first = event.first;
    this.setRowLength = event.rows;
    if (event.sortField !== undefined) {
      this.sortF = event.sortField;
    }
    this.sortO = event.sortOrder > 0 ? 'asc' : 'desc';
    this.fetchAndLoadData();
  }

  onRowSelect(event) {
    // this.rowClickedEvent.emit(this.selectedRecords);
    // this.rowClickedEvent.emit(event);
  }

  onRowUnselect(event) {
    // console.log(event);
    // console.log(this.selectedRecords);
  }

  // actionBtnClick(data: any, action: string) {
  //   console.log(data + ' action:' + action);
  //   const obj = { row: data, class: action };
  //   this.actionBtnClickedEvent.emit(obj);
  // }
  actionBtnClick(event, data: any, action: string) {
    event.stopPropagation();
    const obj = { row: data, class: action };
    this.actionBtnClickedEvent.emit(obj);
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getSelectedRecords() {
    return this.selectedRecords;
  }

  applySearch(searchText: string) {
    this.searchText = searchText;
    this.offset = 0;
    this.first = 0;
    this.fetchAndLoadData();
  }

  // exportGridExcel(event: any) {
  //   const that = this;
  //   this.gridService.downloadExcelGridData(that.getUrl(that.exportUrl + '?' + this.queryParams));
  // }

  // exportGridPdf(event: any) {
  //   const that = this;
  //   this.gridService.downloadPdfGridData(that.getUrl(that.printUrl + '?' + this.queryParams));
  // }


  exportGridExcel(event: any) {
    const that = this;
    const exportUrl = this.queryParams ? that.exportUrl + '?' + this.queryParams : that.exportUrl;
    const fromDate = this.getParameterByName('fromDate', exportUrl);
    const toDate = this.getParameterByName('toDate', exportUrl);
    // console.log(fromDate);
    if (!fromDate && !toDate) {
      this.commonBindingDataService.showMessage(AppSettings.SEVERITY.ERROR, 'From Date and To Date is required');
      return;
    }
    this.gridService.downloadExcelGridData(that.getUrl(exportUrl));
    // this.gridService.downloadExcelGridData(that.getUrl(that.exportUrl + '?'  + this.queryParams));
  }

  exportGridPdf(event: any) {
    const that = this;
    const printtUrl = this.queryParams ? that.printUrl + '?' + this.queryParams : that.printUrl;
    const fromDate = this.getParameterByName('fromDate', printtUrl);
    const toDate = this.getParameterByName('toDate', printtUrl);
    if (!fromDate && !toDate) {
      this.commonBindingDataService.showMessage(AppSettings.SEVERITY.ERROR, 'From Date and To Date is required.');
      return;
    }
    this.gridService.downloadPdfGridData(that.getUrl(printtUrl));
    // this.gridService.downloadPdfGridData(that.getUrl(that.printUrl + '?' + this.queryParams));
  }

  getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  getSavedPagination() {
    let pagination: any[] = this.storageService.getItem(AppSettings.PAGINATION);
    pagination = pagination ? pagination : [];
    const objects = pagination.filter(ele => {
      return ele.uniqId === this.uniqId;
    });
    if (objects.length > 0) {
      return objects[0];
    } else {
      return null;
    }
  }

  setGridPagination(){
    const pagination = this.getSavedPagination();
    const obj = pagination?.pageData;
    this.offset = obj?.offset === null || obj?.offset === undefined ? 0 : obj?.offset;
    this.searchText = obj?.searchText === null || obj?.searchText === undefined ? '' : obj?.searchText;
    this.search = obj?.searchText === null || obj?.searchText === undefined ? '' : obj?.searchText;
  }

  updatePageDataToLocal(pageData: any, key?, val?) {
    let pagination: any[] = this.storageService.getItem(AppSettings.PAGINATION);
    pagination = pagination ? pagination : [];
    const objects = pagination.filter(ele => {
      return ele.uniqId === pageData.uniqId;
    });

    if (objects.length === 0 && pageData.uniqId) {
      pagination.push(pageData);
    } else {
      const index = pagination.findIndex(ele => ele.uniqId === pageData.uniqId);
      if (index >= 0) {
        if (key && val) {
          pagination[index]['pageData'][key] = val;
        } else {
          pagination[index] = pageData;
        }
      }
    }
    this.storageService.setItem(AppSettings.PAGINATION, pagination);
  }


  filterGrid(event: any) {
    event.stopPropagation();
    this.filterGridEvent.emit(event);
  }

  initMoreActionsMenu() {
    
   let moreActionsItems: MenuItem[] = [];

   if(this.exportUrl && this.exportUrl !== '') {
    moreActionsItems.push(
      {
        label: 'Export',
        command: (event) => {
          this.exportGridExcel(event?.originalEvent || event);
        }
      }
    );
   }

    if (this.bulkImportButton && this.bulkImportButton === true) {
      moreActionsItems.unshift(
        { label: 'Import File',
          command: (event) => {
            this.displayImportPopup = true;
            // event.originalEvent.stopPropagation();
            // this.onUploadFile(event?.originalEvent || event);
          }
         },
        { label: 'Download Import Template',
          command: (event) => {
            event.originalEvent.stopPropagation();
            this.downloadImportTemplateAndGuideFile('template');
          }
         },
        { label: 'Download Import Guide',
          command: (event) => {
            event.originalEvent.stopPropagation();
            this.downloadImportTemplateAndGuideFile('guide');
          }
         },
        { separator: true }
      );
    }
    this.moreActionsItems = moreActionsItems;
  }

  downloadImportTemplateAndGuideFile(type: string) {
    const that = this;
    this.userCommonService.getUserMetaData().subscribe(result => {
      if (result.fileImportTemplatesList && result.fileImportTemplatesList.length > 0) {
      for (let i = 0; i < result.fileImportTemplatesList.length; i++) {
            if (this.screenCode == result.fileImportTemplatesList[i].screenCode) {
              if (type === 'template') {
                that.commonBindingDataService.getDocumentDownload(result.fileImportTemplatesList[i].fileId);
              } else if (type === 'guide') {
                that.commonBindingDataService.getDocumentDownload(result.fileImportTemplatesList[i].templateGuideFileId);
              }
            }
          }
        } else {
          that.commonBindingDataService.showMessage(AppSettings.SEVERITY.ERROR, 'Template or Guide file not found');
        }
    }, (error) => {
      that.commonBindingDataService.showMessage(AppSettings.SEVERITY.ERROR, error.general[0].message);
    });
  }

  cancelImport() {
    this.displayImportPopup = false;
  }

  onUploadFile(event) {
    this.uploadedFileName = event.originalFileName;
    const data = {
      "screenCode": this.screenCode,
      "fileName": event.fileId
    }
    this.commonBindingDataService.importBulkFile(data).subscribe(result => {
      this.commonBindingDataService.showMessage(AppSettings.SEVERITY.SUCCESS, result.general[0].message);
      this.displayImportPopup = false;
      this.uploadedFileName = '';
      this.refreshList();
    }, (error) => {
      this.commonBindingDataService.showMessage(AppSettings.SEVERITY.ERROR, error.general[0].message);
      this.uploadedFileName = '';
    });
  }
}
